import { Link } from 'react-router-dom';

import { Badge } from '@/components/atoms';
import { useTemplates } from '@/hooks/useTemplates';

import styles from './Prompts.module.css';
import { motivoLegivel } from '@/services/erroLegivel';

export function Prompts() {
  const { data: templates, isLoading, error } = useTemplates();

  return (
    <section>
      <header className={styles.head}>
        <Link to="/config" className={styles.back}>
          ← Configurações
        </Link>
        <h1 className={styles.title}>Templates de prompt</h1>
        <Badge tone="info" size="sm">
          {templates?.length ?? 0} templates
        </Badge>
      </header>

      <p className={styles.intro}>
        Engenharia travada (Axioma IV). System message, output schema e validação
        são código. Tom, comprimento, anti-padrões e modelo são configuráveis.
      </p>

      {isLoading && <p className={styles.muted}>Carregando…</p>}
      {error && <p className={styles.error}>{motivoLegivel(error)}</p>}

      {templates && templates.length === 0 && (
        <p className={styles.muted}>
          Nenhum template carregado. Verifica <code>backend/templates/*.yaml</code>.
        </p>
      )}

      <ul className={styles.list}>
        {templates?.map((t) => (
          <li key={t.id} className={styles.row}>
            <div className={styles.body}>
              <Link to={`/config/prompts/${t.id}`} className={styles.rowLink}>
                {t.name}
              </Link>
              <p className={styles.rowDesc}>{t.description}</p>
              <div className={styles.meta}>
                {t.model && (
                  <Badge tone="neutral" size="xs">
                    {t.model}
                  </Badge>
                )}
                {t.current_version_number !== null && (
                  <span className={styles.metaItem}>v{t.current_version_number}</span>
                )}
                <span className={styles.metaItem}>
                  {t.versions_count} versã{t.versions_count !== 1 ? 'es' : 'o'}
                </span>
                {t.applies_to.length > 0 && (
                  <span className={styles.metaItem}>
                    usado em: {t.applies_to.join(', ')}
                  </span>
                )}
              </div>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
